var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "pointCloudProcessTrackingModal",
            size: "xl",
            "content-class": "sub-menu-bg-blue-transparent",
            "body-class": "scroll-Container",
            title: "Point Cloud Process Tracking",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            hide: function ($event) {
              return _vm.clearForm()
            },
            shown: function ($event) {
              return _vm.getAutopopulatedData()
            },
          },
        },
        [
          _c(
            "b-container",
            [
              _vm.incomingData != null &&
              (_vm.dprCameraStatus != null ||
                _vm.dprComments != null ||
                _vm.dprDMIStatus != null)
                ? _c(
                    "div",
                    [
                      _c("h3", { staticClass: "px-3 py-2 text-center" }, [
                        _vm._v("Associated DPR Entry"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "px-3 py-2" },
                                [
                                  _c("label", [_vm._v("Camera Status")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.dprCameraStatus,
                                      callback: function ($$v) {
                                        _vm.dprCameraStatus = $$v
                                      },
                                      expression: "dprCameraStatus",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "px-3 py-2" },
                                [
                                  _c("label", [_vm._v("DMI Status")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.dprDMIStatus,
                                      callback: function ($$v) {
                                        _vm.dprDMIStatus = $$v
                                      },
                                      expression: "dprDMIStatus",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "px-3 py-2" },
                                [
                                  _c("label", [_vm._v("DPR Comments")]),
                                  _vm._v(" "),
                                  _c("b-form-textarea", {
                                    staticClass: "text-input",
                                    attrs: { rows: "4", disabled: "" },
                                    model: {
                                      value: _vm.dprComments,
                                      callback: function ($$v) {
                                        _vm.dprComments = $$v
                                      },
                                      expression: "dprComments",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr", {
                        staticStyle: {
                          "border-top": "1px solid rgba(255, 255, 255, 0.5)",
                        },
                      }),
                    ],
                    1
                  )
                : !_vm.inputtingPCPT
                ? _c(
                    "b-row",
                    { staticClass: "p-3" },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c("span", { staticClass: "alert alert-danger" }, [
                          _c("b", { staticStyle: { "text-shadow": "none" } }, [
                            _vm._v(" No corresponding DPR entry found. "),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Drive")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.driveLabel,
                              callback: function ($$v) {
                                _vm.driveLabel = $$v
                              },
                              expression: "driveLabel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Assigned To")]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { options: _vm.assignedToOptions },
                            model: {
                              value: _vm.assignedTo,
                              callback: function ($$v) {
                                _vm.assignedTo = $$v
                              },
                              expression: "assignedTo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("System")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.systemSelected,
                              callback: function ($$v) {
                                _vm.systemSelected = $$v
                              },
                              expression: "systemSelected",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("JDAY")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { type: "number", disabled: "" },
                            model: {
                              value: _vm.jDay,
                              callback: function ($$v) {
                                _vm.jDay = $$v
                              },
                              expression: "jDay",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Date")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { type: "date", disabled: "" },
                            model: {
                              value: _vm.date,
                              callback: function ($$v) {
                                _vm.date = $$v
                              },
                              expression: "date",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("State")]),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: {
                              options: _vm.stateOptions,
                              multiple: true,
                              "close-on-select": false,
                              placeholder: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.state,
                              callback: function ($$v) {
                                _vm.state = $$v
                              },
                              expression: "state",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Collection Type")]),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: {
                              options: _vm.collectionTypesSelection,
                              multiple: true,
                              "close-on-select": false,
                              placeholder: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.collectionType,
                              callback: function ($$v) {
                                _vm.collectionType = $$v
                              },
                              expression: "collectionType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Status")]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { options: _vm.statusOptions },
                            model: {
                              value: _vm.status,
                              callback: function ($$v) {
                                _vm.status = $$v
                              },
                              expression: "status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              model: {
                                value: _vm.checkedOldData,
                                callback: function ($$v) {
                                  _vm.checkedOldData = $$v
                                },
                                expression: "checkedOldData",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Checked Against Old Data\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.receivedFromField,
                                callback: function ($$v) {
                                  _vm.receivedFromField = $$v
                                },
                                expression: "receivedFromField",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Received from field\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Date Started")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { type: "date" },
                            model: {
                              value: _vm.dateStarted,
                              callback: function ($$v) {
                                _vm.dateStarted = $$v
                              },
                              expression: "dateStarted",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Date Completed")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { type: "date" },
                            model: {
                              value: _vm.dateCompleted,
                              callback: function ($$v) {
                                _vm.dateCompleted = $$v
                              },
                              expression: "dateCompleted",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [
                            _vm._v("CM Acquisition Summary (miles)"),
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.cmAcqSumRounded,
                              callback: function ($$v) {
                                _vm.cmAcqSumRounded = $$v
                              },
                              expression: "cmAcqSumRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [
                            _vm._v("Ramp Acquisition Summary (miles)"),
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.rampAcqSumRounded,
                              callback: function ($$v) {
                                _vm.rampAcqSumRounded = $$v
                              },
                              expression: "rampAcqSumRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Aerial Recollect (miles)")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.aerialRecollectMilesRounded,
                              callback: function ($$v) {
                                _vm.aerialRecollectMilesRounded = $$v
                              },
                              expression: "aerialRecollectMilesRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Primary Roads (miles)")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.primaryRoadsRounded,
                              callback: function ($$v) {
                                _vm.primaryRoadsRounded = $$v
                              },
                              expression: "primaryRoadsRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Secondary Roads (miles)")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.secondaryRoadsRounded,
                              callback: function ($$v) {
                                _vm.secondaryRoadsRounded = $$v
                              },
                              expression: "secondaryRoadsRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Tertiary Roads (miles)")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.tertiaryRoadsRounded,
                              callback: function ($$v) {
                                _vm.tertiaryRoadsRounded = $$v
                              },
                              expression: "tertiaryRoadsRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Days in backlog")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { type: "number", disabled: "" },
                            model: {
                              value: _vm.daysInBacklog,
                              callback: function ($$v) {
                                _vm.daysInBacklog = $$v
                              },
                              expression: "daysInBacklog",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "px-3 pt-2" },
                                [
                                  _c("label", [_vm._v("Date Received")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: { type: "date" },
                                    model: {
                                      value: _vm.dateReceived,
                                      callback: function ($$v) {
                                        _vm.dateReceived = $$v
                                      },
                                      expression: "dateReceived",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Total Miles")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.totalMilesRounded,
                              callback: function ($$v) {
                                _vm.totalMilesRounded = $$v
                              },
                              expression: "totalMilesRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Trail Miles")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.trailMilesRounded,
                              callback: function ($$v) {
                                _vm.trailMilesRounded = $$v
                              },
                              expression: "trailMilesRounded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "px-3 py-2" },
                        [
                          _c("label", [_vm._v("Comments")]),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            attrs: { rows: "4" },
                            model: {
                              value: _vm.comments,
                              callback: function ($$v) {
                                _vm.comments = $$v
                              },
                              expression: "comments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            size: "lg",
                            type: "submit",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm(
                                _vm.assignedToOriginal == _vm.assignedTo
                              )
                            },
                          },
                        },
                        [_vm._v("\n            Submit\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "PCPTReassignmentModal",
            size: "md",
            "content-class": "menu-bg-blue-transparent-modal",
            "body-class": "scroll-Container",
            title: "Track Reassignment",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-container",
            { staticClass: "text-center" },
            [
              _c(
                "b-row",
                { staticClass: "row-input py-2" },
                [
                  _c("b-col", { staticClass: "row-label-left-justify" }, [
                    _c("h5", [_vm._v("Warning:")]),
                    _vm._v(
                      " You are attempting to assign this track when it has already been assigned to\n          " +
                        _vm._s(
                          _vm.assignedToOptions.find(
                            (x) => x.value === this.assignedToOriginal
                          ).text
                        ) +
                        ".\n          Are you sure you wish to reassign this track?\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "row-input py-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            size: "lg",
                            type: "submit",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.reassignmentConfirmation()
                            },
                          },
                        },
                        [_vm._v("\n            Submit\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }